/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

interface IApplicationInsights {
  instrumentationKey: string;
}

interface IOktaSettings {
  clientId: string;
  baseUrl: string;
  issuer: string;
  scopes: string[];
  testing: {
    disableHttpsCheck: string;
  };
  redirectUri: string;
  postLogOutRedirectUri: string;
  recoveryPasswordUrl: string;
}

export interface ISitefinityCmsSettings {
  siteSettings: Array<ISiteSetting>;
  sitefinityMiddleWare: string;
}

interface ISiteSetting {
  id: string;
  name: string;
  hostName: string;
  provider: string;
  redirectUri: string;
  postLogOutRedirectUri: string;
  groupId: string;
  groupName: string;
  oktaPrefix: string;
}

interface IDeviceInventorySettings {
  deviceInventoryUrl: string;
  deviceInventorySmartUrl: string;
  autocompleteMfeBaseUrl: string;
  deviceInventoryMfeBaseUrl: string;
}

interface IMiddleWareSettings {
  middlewareUrl: string;
  subscriptionKey: string;
  contractPdfEndPoint: string;
  accountPath: string;
  billingPath: string;
  servicePath: string;
  supportPath: string;
  deviceInventoryMiddlewareUrl: string;
  programCode: string;
  clientId: string;
  associateNumber: string;
  secondaryAccPath: string;
  cprcouponpath: string;
}

interface IEquipmentSearchApiSettings{
  key: string;
  baseUrl: string;
}

export interface IPreInitAppSettings {
  applicationInsights: IApplicationInsights | null;
  okta: IOktaSettings | null;
  sitefinityCms: ISitefinityCmsSettings | null;
  deviceinventory: IDeviceInventorySettings | null;
  deviceContentSdkApiKey: string | null;
  middleWare: IMiddleWareSettings | null;
  ptpoId: string | null;
  featureFlags: IFeatureFlags | null;
  sspCategoryMapFile: string | null;
  isProduction: string;
  equipmentSearchApi: IEquipmentSearchApiSettings | null;
  environmentName: string | null;
  isDatadogRUMEnabled: string | null;
  datadogRUMConfig: IDatadogRumConfig | null;
}

export interface IDatadogRumConfig {
  applicationId: string;
  clientToken: string;
  sampleRate: string;
  replaySampleRate: string;
  version: string;
  cid: string;
  scid: string;
}

export interface IFeatureFlags {
  enableClaimsFlow: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PreInitSettingsService {
  settings: Observable<Readonly<IPreInitAppSettings>>;

  private settingsSource: BehaviorSubject<IPreInitAppSettings> = new BehaviorSubject<IPreInitAppSettings>({
    applicationInsights: null,
    okta: null,
    sitefinityCms: null,
    deviceinventory: null,
    deviceContentSdkApiKey: null,
    middleWare: null,
    ptpoId: null,
    featureFlags: null,
    sspCategoryMapFile: null,
    isProduction: null,
    equipmentSearchApi: null,
    environmentName: null,
    isDatadogRUMEnabled: null,
    datadogRUMConfig: null
  });

  constructor() {
    this.settings = this.settingsSource.asObservable();
  }

  setSettings(settings: Partial<IPreInitAppSettings>) {
    const updatedConfig = { ...this.settingsSource.value, ...settings };

    this.settingsSource.next(updatedConfig);
  }

  getSettings(): Readonly<IPreInitAppSettings> {
    if(this.settingsSource.value.applicationInsights!=null)
      return this.settingsSource.value;
    else {
      return window['pghconfig'];
    }
  }

  getSiteSettings() {
    let setting = this.getSettings().sitefinityCms.siteSettings.find(x => x.hostName.toLowerCase() === window.location.hostname.toLowerCase());
    if(setting === undefined) {
      console.log('Setting not found for ' + window.location.hostname.toLowerCase());
      throw new Error('Setting not found for ' + window.location.hostname.toLowerCase());
    }
    setting.redirectUri = window.location.origin + '/login/callback';
    return setting;
  }
}
